import React, { useEffect, useState } from 'react';
import WithStandardLayout from '@/layouts/withStandard.layout';
import SignupPage from '@/components/LoginPage/SignupPage';
import initializeIconLibrary from '@/utils/fontAwesomeLibrary';
import 'bootstrap/dist/css/bootstrap.min.css';
import useAccount from '@/hooks/useAccount';
import { useRouter } from 'next/router';
import { buildServerSideProps } from '@/utils/server';

initializeIconLibrary();

const Signup = () => {
  const { account } = useAccount();
  const router = useRouter();
  const { invitation_id, invitation_token, organization_id, organization_name, pro } = router.query;
  const signupInvitation = { invitation_id, invitation_token, organization_id, organization_name, is_professional: pro === '1' };

  useEffect(() => {
    account.setNextPage('/');
  }, []);

  return <SignupPage signupInvitation={signupInvitation} />;
};

export const getServerSideProps = buildServerSideProps();

Signup.getLayout = function getLayout(page) {
  return <WithStandardLayout host={page.props.host}>{page}</WithStandardLayout>;
};

export default Signup;
